import { feasibilityActions, popupActions } from '../../services';

export const feasibilityReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case feasibilityActions.LOADED:
      return JSON.parse(action.data?.data);
    case feasibilityActions.LOADRESULT:
      //Adding product code to result
      return {...state, result: JSON.parse(action.data?.data)};
    case feasibilityActions.GETRESULT:
      return {}
    case feasibilityActions.RESET:
      //return {...state, productCode: JSON.parse(action.data?.data)};
      return {}
    case feasibilityActions.GETCONFIGURATORID:
      return {...state, productCode: JSON.parse(action.data?.data)};
    default:
      return state;
  }
};
